import React, {FC, useEffect} from 'react'
import {useFormContext, Controller} from 'react-hook-form'
import {FilterRegex} from '../../../util/functions'
type InputProps = {
  name: string
  textPlaceholder?: string
  disabled?: boolean
  Uppercase?: boolean
  type?: string
  maxLength?: number
  readOnly?: boolean
}

const InputText: FC<InputProps> = ({
  name,
  textPlaceholder,
  maxLength = 1000,
  disabled = false,
  Uppercase = true,
  type = 'text',
  readOnly = false,
  ...props
}) => {
  const {
    control,
    formState: {errors},
    watch,
    setValue,
  } = useFormContext()
  const value = watch(name) ?? ''
  useEffect(() => {
    if (value === undefined) {
      setValue(name, '')
    }
  }, [value, setValue, name])
  let regex = FilterRegex(type)
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: {onChange: (value: string) => void},
  ) => {
    let value = e.target.value
    if (!regex.test(value)) {
      return
    }
    if (Uppercase) {
      value = value.toUpperCase()
    }

    field.onChange(value)
  }

  return (
    <div className='sdx_form_input'>
      <Controller
        name={name}
        control={control}
        defaultValue={value}
        render={({field}) => (
          <input
            type='text'
            className='form-control sdx-centra-input-form'
            {...field}
            style={{backgroundColor: readOnly ? '#f5f5f5' : 'white'}}
            placeholder={textPlaceholder}
            maxLength={maxLength}
            disabled={disabled}
            readOnly={readOnly}
            onChange={(e) => handleChange(e, field)}
          />
        )}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputText
